import type { ReactNode } from "react";

export type DocumentTableSkeletonColumn = {
  className?: string;
  header: ReactNode;
  id: string;
  placeholderClassName?: string;
};

type DocumentTableSkeletonProps = {
  columns: DocumentTableSkeletonColumn[];
  rowCount?: number;
  showSelectionColumn?: boolean;
};

const DocumentTableSkeleton = ({
  columns,
  rowCount = 3,
  showSelectionColumn = false,
}: DocumentTableSkeletonProps) => {
  return (
    <div
      className="cle-documents-table table-responsive border-start-0 border-end-0 rounded-0"
      aria-hidden="true"
    >
      <table className="cle-documents-table__table table table-hover align-middle mb-0">
        <thead>
          <tr>
            {showSelectionColumn ? (
              <th scope="col" className="cle-documents-table__selection-cell" />
            ) : null}
            {columns.map((column) => (
              <th key={column.id} scope="col" className={column.className}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="placeholder-glow">
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {showSelectionColumn ? (
                <td className="cle-documents-table__selection-cell">
                  <span className="placeholder col-5 rounded" />
                </td>
              ) : null}
              {columns.map((column) => (
                <td key={column.id} className={column.className}>
                  <span
                    className={`placeholder ${
                      column.placeholderClassName ?? "col-6 rounded"
                    }`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentTableSkeleton;
